import React, { FC, useState, useEffect } from 'react';
import { SkeletonText } from '@ems/client-design-system';
import { withQueryStringUpdater } from 'src/@app/hocs/withQueryStringUpdater';
import { useConfigSelectors } from 'src/@app/reducers/configReducer';
// selectors
import { useFilterDataSelectors, useLanguageSelectors } from 'src/@app/reducers';
import { useDataSelectors } from 'src/@noiseEvents/reducers/dataReducer';
// components
import { DateFilter } from 'src/components';
import { IHeaderContainer } from 'src/@noiseEvents/props';
import { PageHeader } from 'src/components';
import { formatNumber, convertObjectKeys } from 'src/utils';
import { createSelectItems } from 'src/@noiseEvents/functions';

export const HeaderContainer: FC<IHeaderContainer> = ({ updateUrl }) => {
  const [operationsMapping, setoperationsMapping]: any = useState({
    operationType: [],
    airportId: [],
    remoteAirportId: [],
    runwayName: [],
    aircraftCategory: [],
    aircraftType: [],
  });

  const pluralizeOperations = {
    operationType: 'operationTypes',
    airportId: 'airportIds',
    remoteAirportId: 'remoteAirportIds',
    runwayName: 'runwayNames',
    aircraftCategory: 'aircraftCategories',
    aircraftType: 'aircraftTypes',
  };

  // Configuration
  const configSelectors = useConfigSelectors();
  const {
    operations: {
      filter: { nullable },
    },
  } = configSelectors.getConfig();

  // filters data
  const filtersSelectors = useFilterDataSelectors();
  const operationFilterData = filtersSelectors.getOperationsFilterData();

  // Translation
  const languageSelectors = useLanguageSelectors();
  const {
    components: {
      labels: {
        table: { totalItems },
      },
      lists: { aircraftCategories, operationTypes, extraFilterValues },
    },
    screens: {
      noiseEvents: { title: pageTitle },
    },
  } = languageSelectors.getLanguage();

  const dataSelectors = useDataSelectors();
  const { totalCount } = dataSelectors.getDataInformation();

  useEffect(() => {
    const dataItems = {};

    Object.keys(operationsMapping).map(item => {
      Object.assign(dataItems, {
        [item]: createSelectItems(
          operationFilterData[pluralizeOperations[item]],
          item,
          nullable && nullable.includes(pluralizeOperations[item]),
          translatedList
        ),
      });
    });

    setoperationsMapping(dataItems);
  }, []);

  const DateFilterHoc = withQueryStringUpdater(DateFilter, updateUrl);

  const translatedList = convertObjectKeys({
    ...aircraftCategories,
    ...operationTypes,
    ...extraFilterValues,
  });

  return (
    <PageHeader title={pageTitle}>
      <SkeletonText loading={typeof totalCount === 'undefined' || totalCount === -1} width="4rem">
        <span className="page-count">
          {totalCount && formatNumber(totalCount)} {totalItems}
        </span>
      </SkeletonText>
      <div>
        <DateFilterHoc />
      </div>
    </PageHeader>
  );
};
